import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"

const StationsForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [formData, setFormData] = useState({
        name: '',
        power: '',
        address: ''
    })
    const {name, power, address} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect (() => {
        if (location.state){
            const {station} = location.state
            setFormData({
                name: station.name,
                power: station.power,
                address: station.address
            })
        }

    }, [location])

    

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const stationData = {name, power, address}
        addStation(stationData)
    }
    
    // add station
    const addStation = async (stationData) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/stations/', stationData)
            if (response.status === 201){
                toast.success('Successfully created')
                navigate('/stations')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                setErrors(error.response.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Create New Station</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="Station Name"
                                name="name"
                                type="text"
                                label="Name"
                                value={name}
                                onChange={onChange}
                                error={errors.name}
                            />
                        </div>

                        <div className="col-md-4">
                        <InputField
                            placeholder="Station Power"
                            name="power"
                            type="text"
                            label="Power"
                            value={power}
                            onChange={onChange}
                            error={errors.power}
                        />
                        </div>

                        <div className="col-md-4">
                        <InputField
                            placeholder="Station Address"
                            name="address"
                            type="text"
                            label="Address"
                            value={address}
                            onChange={onChange}
                            error={errors.address}
                        />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Station" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default StationsForm
